import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Box, Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import React from 'react';

import { DialogChromeFooter, DialogChromeHeader } from 'components/atoms/Dialog/DialogChrome';
import { CopyableBlock } from './CopyableCliBlock';

interface ItEmailDialogProps {
  open: boolean;
  onClose: () => void;
  subject: string;
  body: string;
  mailtoHref: string;
}

const ItEmailDialog = ({ open, onClose, subject, body, mailtoHref }: ItEmailDialogProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth aria-labelledby="it-email-summary-title">
    <DialogChromeHeader
      title="Ready-made email for IT"
      titleId="it-email-summary-title"
      subtitle="Use this when you need IT help across all AWS CLI and S3 setup steps."
      closeButtonAriaLabel="Close IT email summary"
      onClose={onClose}
    />
    <DialogContent dividers>
      <Stack spacing={1.5}>
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            Subject
          </Typography>
          <CopyableBlock text={subject} copyButtonAriaLabel="Copy IT email subject" />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            Email body
          </Typography>
          <CopyableBlock text={body} copyButtonAriaLabel="Copy IT email body" />
        </Box>
      </Stack>
    </DialogContent>
    <DialogChromeFooter>
      <Button
        component="a"
        href={mailtoHref}
        target="_blank"
        rel="noreferrer"
        variant="outlined"
        startIcon={<EmailOutlinedIcon />}
        sx={{ alignSelf: 'flex-start' }}
      >
        Open email draft
      </Button>
      <Button onClick={onClose}>Close</Button>
    </DialogChromeFooter>
  </Dialog>
);

export default ItEmailDialog;
